
var WEB = {
    setDocumentTitle() {
        var curPath = AppFate.$router.history.current.path,
            detailData = AppFate.$store.state.detail,
            famouspediaData = AppFate.$store.state.famouspedia;
        
        if(curPath.indexOf('detail') != -1 && detailData) {
            document.title = detailData.personInfo.f_name + '八字';
        }else if(curPath.indexOf('comment') != -1 && detailData){
            document.title = detailData.personInfo.f_name + '批盘';
        }else if(curPath.indexOf('discuss') != -1 && detailData){
            document.title = detailData.personInfo.f_name + '论盘';
        }else if(curPath.indexOf('famouspedia') != -1){
            setTimeout(() => {
                document.title = famouspediaData.curPediaBaziInfo.f_name + '八字百科';
            }, 100);
        }else {
            document.title = '木火通明八字';
        }
    }
}

export {
    WEB
}